import { REACT_APP_GOOGLE_MAPS_API_KEY } from '@common/utils/keys/googleMaps';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { reducerPaths } from './app/reducerPaths';
import { AlertDialog } from './components/custom/AlertDialog';
import ProtectedRoute from './components/custom/ProtectedRoutes';
import AuthLayout from './pages/AuthPages/AuthLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import { routes } from './utils/constants/routes';
import { useLazyGetSellerProfileQuery } from './toolkit/seller/sellerApi';

function App() {
  const libraries = React.useMemo(() => {
    return ['places'];
  }, []);

  const auth = useSelector((store) => store[reducerPaths.auth]);

  const [getProfileDetailsApiHandler, getProfileDetailsApiData] = useLazyGetSellerProfileQuery();

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY,
    id: 'google-maps',
    libraries,
  });

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      (async () => {
        await getProfileDetailsApiHandler();
      })();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <div className="App">
          <React.Suspense fallback={<></>}>
            <Routes>
              {/* Public routes */}

              {!auth?.token ? (
                <Route path={routes.auth} element={<AuthLayout />} />
              ) : (
                <Route path={routes.auth} element={<Navigate to={routes.dashboardNavigation} />} />
              )}

              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route path={`${routes.dashboard}`} element={<Dashboard />} />
              </Route>

              {/* Redirects */}
              {/* {auth?.token ? (
                <Route path="*" element={<Navigate to={routes.dashboardNavigation} />} />
              ) : (
                <Route path="*" element={<Navigate to={routes.authSignin} />} />
              )} */}
            </Routes>
          </React.Suspense>
        </div>

        <AlertDialog />
      </Router>
    </LocalizationProvider>
  );
}

export default App;
